import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { EVENT_NAME, dispatchCustomEvent } from '../../project/utilities';
import ListView from '../../Shared/ListView';
import { COLUMN_TYPE } from '../../Shared/ListView/helper';
import { Project } from '../../project/Project';

const listUpdateEvent = EVENT_NAME.PRODUCT_LIST_UPDATE;

export default function ImportDetail(props) {
    const { fileData } = props;
    const { type } = useParams();

    const columns = [
        {
            text: 'SalesNetwork',
            field: 'salesNetwork',
            type: COLUMN_TYPE.TEXT,
            width: 120,
            fixed: 'left'
        },
        {
            text: 'Code',
            field: 'code',
            type: COLUMN_TYPE.TEXT,
            width: 100,
            fixed: 'left'
        },
        {
            text: 'brand',
            field: 'brand',
            type: COLUMN_TYPE.TEXT,
            width: 120,
            fixed: 'left'
        },
        {
            text: 'language',
            field: 'language',
            type: COLUMN_TYPE.TEXT,
            width: 80,
            fixed: 'left'
        },
           ...Array.from({ length: 20 }, (_, i) => {
        const index = i + 1;
        return [
            {
                text: `text.url_doc`,
                field: `urlDoc${index}`,
                type: COLUMN_TYPE.TEXT,
                width: 550,
                index: index,
            },
            {
                text: `text.type_doc`,
                field: `type${index}`,
                type: COLUMN_TYPE.TEXT,
                width: 80,
                index: index,
            },
            {
                text: `text.name_doc`,
                field: `nameDoc${index}`,
                type: COLUMN_TYPE.TEXT,
                width: 150,
                index: index,
            },
            {
                text: `text.category_doc`,
                field: `categoryDoc${index}`,
                type: COLUMN_TYPE.TEXT,
                width: 150,
                index: index,
            }
        ];
    }).flat(),
        Project.getImportActionColumn(COLUMN_TYPE.TEXT, "right"),
        Project.getImportMessageColumn(COLUMN_TYPE.TEXT, "right")
        // {
        //     text: 'action',
        //     field: 'Action',
        //     render: (text, record) => {
        //         return (
        //             <wrap>
        //                 <group compact="">
        //                     {Project.getColorAction(text)}
        //                 </group>
        //             </wrap>
        //         );
        //     },
        //     type: COLUMN_TYPE.TEXT,
        //     width: 100
        //     // fixed: 'right',
        // },
        // //...getColumns("pump", t),
        // {
        //     text: 'text.message',
        //     field: 'Message',
        //     type: COLUMN_TYPE.TEXT,
        //     fixed: 'right'
        // },
        // {
        //     type: COLUMN_TYPE.ACTION,
        //     fixed: "right"
        // },
    ]
    useEffect(() => {
        dispatchCustomEvent(listUpdateEvent);
    }, [type]);

    return (
        <ListView
            dataSource={fileData || []}
            columnConfig={columns}
            rowClassName={Project.getRecordActionClass}
            nameField='sku'
            skipNewButton
            className='scroll_fix'
            skipEdit
        />
    );
}